module.exports = require('./helpers/bundle-url').getBundleURL('k3fDG') + "project-icon.893ec8ff.svg";